if (!customElements.get('sticky-add-to-bag')) {
  class StickyAddToBag extends HTMLElement {
    constructor() {
      super();
      this.visibleClass = 'is-visible';
      this.observer = null;
      this.mainAddButton = null;
      this.footer = null;
      this.stickyContent = this.querySelector('[data-component="sticky-add-to-bag-inner"]');
      this.stickySubmitButton = this.querySelector('[data-component="sticky-add-to-bag-submit"]');
      this.stickyOpenVariantPicker = this.querySelector('[data-component="sticky-add-to-bag-open-variant"]');
      this.stickyVariantPicker = document.getElementById('sticky-add-to-bag-variant-picker');
      
      this.stickyVariantPickerClose = this.stickyVariantPicker?.querySelector('[data-component="sticky-add-to-bag-variant-picker-close"]')
      this.optionSelectors = this.stickyVariantPicker?.querySelectorAll('[data-component="option-selector"]')
      this.options = this.stickyVariantPicker?.querySelectorAll('[data-component="option"]')
      this.values = this.stickyVariantPicker?.querySelectorAll('[data-component="value"]')
      this.quantitySelector = this.stickyVariantPicker?.querySelector('[data-component="quantity-selector"]')
      this.quantityDecrease = this.stickyVariantPicker?.querySelector('[data-component="quantity-decrease"]')
      this.quantityValue = this.stickyVariantPicker?.querySelector('[data-component="quantity-value"]')
      this.quantityIncrease = this.stickyVariantPicker?.querySelector('[data-component="quantity-increase"]')
      this.stickyAddToBagAddBtn = this.stickyVariantPicker?.querySelector('[data-component="sticky-add-to-bag-add-btn"]')

      // Find the main add-to-cart button in the product section
      this.mainAddButton = document.querySelector('[data-add-to-cart-text]');
      // The sticky element to show/hide is the parent <section> (per schema tag: "section")
      this.stickySection =
        this.closest('section.sticky-add-to-bag-cc') || this.closest('section') || this.parentElement;
      this.variantData = {};

      this.formData = new FormData();

      this.stickyAddToCartForm = document.getElementById('sticky-product-form');

      this.variantIdInput = this.querySelector('[name="id"]');

      this.variantPickerEl =
        document.getElementsByTagName('variant-picker')[0] ?? document.createElement('variant-picker');
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.getVariantData();
      this.setupEventlisteners();
      this.showSticky();
      this.updateStickyAvailability();
      this.updateStickyButtonText(this.findVariantById(this.variantIdInput?.value));
      console.log('[StickyAddToBag] Initialized');
    }

    showSticky() {
      const target = this.stickySection || this;
      target.classList.add(this.visibleClass);
    }

    setupEventlisteners() {
      this?.stickySubmitButton?.addEventListener('click', this.handleAddToBag.bind(this));

      this?.stickyOpenVariantPicker?.addEventListener('click', this.showStickyVariantPicker.bind(this));

      this?.stickyVariantPickerClose?.addEventListener('click', this.hideStickyVariantPicker.bind(this))

      this?.variantPickerEl?.addEventListener('on:variant:change', this.handleVariantChange.bind(this));

      this?.options?.forEach((option) => {
        option.addEventListener('change', this.handleStickyVariantChange.bind(this));
      });

      this?.quantityDecrease?.addEventListener('click', this.handleQuantityDecrease.bind(this));

      this?.quantityIncrease?.addEventListener('click', this.handleQuantityIncrease.bind(this));

      this?.stickyAddToBagAddBtn?.addEventListener('click', this.handleAddToBagFromVariantPicker.bind(this));
    }

    addToBag() {
      this.stickySubmitButton?.setAttribute('disabled', '');
      this.stickyAddToBagAddBtn?.setAttribute('disabled', '');
      this.mainAddButton?.setAttribute('disabled', '');
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: this.formData,
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          this.stickySubmitButton?.removeAttribute('disabled');
          this.stickyAddToBagAddBtn?.removeAttribute('disabled');
          this.mainAddButton?.removeAttribute('disabled');
        });
    }

    handleAddToBag() {
      this.getFormData();
      if (window.isFormDataEmpty) return;
      this.addToBag();
    }

    handleAddToBagFromVariantPicker() {
      this.getFormData();
      if (window.isFormDataEmpty) return;
      this.hideStickyVariantPicker();
      this.addToBag();
    }

    handleVariantChange(event) {
      const detail = event?.detail;
      const variant = detail?.variant;
      const selectedOptions = detail?.selectedOptions;

      if (variant) {
        const id = Number(variant.id);
        if (!isNaN(id)) {
          this.variantIdInput.value = String(id);
        }
      }

      if (selectedOptions) {
        this.optionSelectors?.forEach((selector, index) => {
          const value = selectedOptions[index];
          if (value == null) return;
          const radio = selector.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
          if (radio) radio.checked = true;
        });
      }

      this.updateStickyAvailability();
      this.updateStickyButtonText(variant);
    }

    showStickyVariantPicker() {
      console.log('test0r1', this.stickyVariantPicker);
      if (this.stickyVariantPicker instanceof HTMLDialogElement) {
        this.stickyVariantPicker.showModal();
      }
    }

    hideStickyVariantPicker() {
      this.stickyVariantPicker.close()
    }

    handleVariantPicker() {}

    handleStickyVariantChange(event) {
      const changedRadio = event.target;
      const stickySelector = changedRadio.closest('[data-component="option-selector"]');
      if (!stickySelector) return;

      const optionIndex = Array.from(this.optionSelectors).indexOf(stickySelector);
      if (optionIndex === -1) return;

      const mainSelector = this.variantPickerEl.querySelectorAll('.option-selector')[optionIndex];
      if (!mainSelector) return;

      const mainRadio = mainSelector.querySelector(`input[type="radio"][value="${CSS.escape(changedRadio.value)}"]`);
      if (!mainRadio) return;

      mainRadio.checked = true;
      mainRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    handleQuantityDecrease() {
      console.log('test0r3');
    }

    handleQuantityIncrease() {
      console.log('test0r4');
    }

    findVariantById(id) {
      const numId = Number(id);
      if (isNaN(numId)) return null;
      return this.variantData?.variants?.find((v) => v.id === numId) || null;
    }

    updateStickyAvailability() {
      if (!this.optionSelectors || !this.variantData?.variants) return;

      const selectedOptions = Array.from(this.optionSelectors).map(
        (sel) => sel.querySelector('input:checked')?.value ?? null,
      );

      this.optionSelectors.forEach((selector, selectorIndex) => {
        selector.querySelectorAll('[data-component="option"]').forEach((radio) => {
          let available = false;
          this.variantData.variants.forEach((v) => {
            let matches = 0;
            for (let i = 0; i < selectorIndex; i += 1) {
              if (v.options[i] === selectedOptions[i] || selectedOptions[i] === null) {
                matches += 1;
              }
            }
            if (
              v.options[selectorIndex] === radio.value
              && matches === selectorIndex
              && v.available
            ) {
              available = true;
            }
          });

          const label = radio.nextElementSibling;
          if (label) label.classList.toggle('sadtb_is-unavailable', !available);
        });
      });
    }

    updateStickyButtonText(variant) {
      const variantAvailable = !!(variant && variant.available);
      const unavailableStr = variant ? theme.strings.noStock : theme.strings.noVariant;

      const apply = (btn, disable) => {
        if (!btn) return;
        const defaultText = btn.dataset.defaultText || btn.textContent.trim();
        btn.textContent = variantAvailable ? defaultText : unavailableStr;
        if (disable) btn.disabled = !variantAvailable;
      };

      apply(this.stickySubmitButton, true);
      apply(this.stickyOpenVariantPicker, false);
      apply(this.stickyAddToBagAddBtn, true);
    }

    getVariantData() {
      const dataEl = this.querySelector('[type="application/json"]');
      this.variantData = JSON.parse(dataEl.textContent);
    }

    getFormData() {
      const formData = new FormData(this.stickyAddToCartForm);
      this.formData = formData;
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

  }

  customElements.define('sticky-add-to-bag', StickyAddToBag);
}
